import {Alert, Button, Col, Modal, Result, Row, Spin} from 'antd';
import {UserOutlined, LoadingOutlined} from '@ant-design/icons';
import {useAppSelector} from '../../../common/hooks';
import {stationGroupEmployeesList} from '../../setup/station/stationGroups/stationGroupEmployees/stationGroupEmployeesSlice';

const SwapModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const swapData = useAppSelector((state) => state.rackScreen.swap);

  return (
    <Modal
      open={isOpen}
      //onCancel={() => setIsOpen(false)}
      //cancelButtonProps={<></>}
      width={1200}
      closable={false}
      footer={null}
      title='Swap'
      maskClosable={false}
    >
      {swapData.currentStep === 0 && (
        <Row style={{padding: '50px 10px 20px 10px'}} justify={'center'}>
          <Spin spinning={true} indicator={<LoadingOutlined style={{fontSize: 70}} />} />
        </Row>
      )}
      {swapData.currentStep === 1 && (
        <>
          <Row style={{padding: '20px 10px 20px 10px'}}>
            <Col span={swapData.customerName !== '' ? 18 : 24}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1 style={{fontSize: '50px', fontWeight: '20px'}}>
                  {swapData.animation.alt === 'Insert Battery'
                    ? swapData.emptySlot + 1
                    : swapData.chargedSlot + 1}
                </h1>
                <h2 style={{textTransform: 'uppercase', paddingBottom: '20px'}}>
                  {swapData.animation.alt}
                </h2>

                <img src={swapData.animation.src} alt={swapData.animation.alt} />
              </div>
            </Col>
            {swapData.customerName !== '' && (
              <>
                <Col span={2}>
                  <div style={{height: '100%', borderLeft: '2px solid #eb050570 '}}></div>
                </Col>
                <Col span={4}>
                  <UserOutlined
                    style={{
                      fontSize: '70px',
                      color: '#1890ff',
                      paddingBottom: '20px',
                      paddingLeft: '30px',
                    }}
                  />

                  <h3>Name : {swapData.customerName}</h3>
                  <h3> Batteries : {swapData.totalBattery} </h3>
                </Col>
              </>
            )}
          </Row>

          <Row>
            <Col span={24}>
              {swapData.warningMessage.length > 3 && (
                <Alert message={swapData.warningMessage} type='warning' />
              )}
            </Col>
          </Row>
        </>
      )}
      {swapData.currentStep === 2 && (
        <Row style={{padding: '20px 10px 20px 10px'}}>
          <Col span={24}>
            <div style={{textAlign: 'center'}}>
              <h2>Total Amount (Rs.) : {swapData.billing.amount}</h2>
              <h2>
                Remaining Swap :{' '}
                {swapData.billing.swap_count >= 0 ? swapData.billing.swap_count : 0}
              </h2>
            </div>
          </Col>
        </Row>
      )}
      {swapData.currentStep === 3 && (
        <>
          <Result status='success' title='Swaping Successfull, Please Visit Again.' />
          <Button
            type='primary'
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Close
          </Button>
        </>
      )}
      {swapData.currentStep === 9 && (
        <Result
          status='error'
          title='Transaction Failed'
          subTitle={<h4>{swapData.terminateMessage}</h4>}
          extra={[
            <Button
              type='primary'
              onClick={() => {
                setIsOpen(false);
              }}
              key={'close'}
            >
              Close
            </Button>,
          ]}
        ></Result>
      )}
    </Modal>
  );
};

export default SwapModal;
